export const SAVE_APPLICATIONS_FILTER = 'SAVE_APPLICATIONS_FILTER';
export const saveApplicationsFilter = (text) => ({
    type: SAVE_APPLICATIONS_FILTER,
    payload: {text}
});